import React from 'react';
import sign from '../../images/signature-2.png'
import about from '../../images/about3.jpg'
import rotate from '../../images/rotate-text2.svg'

const About4 = (props) => {

    return (
        <section className="wpo-about-section-s4 section-padding" id='about'>
            <div className="container">
                <div className="about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div className="about-img">
                                <img src={about} alt="Isuru Gimhan - About me" loading="lazy" />
                                <div className="round-text">
                                    <img src={rotate} alt="Creative digital designer" loading="lazy" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-1 order-lg-2 order-1">
                            <div className="about-content">
                                <h2>Why You Should Hire Me?</h2>
                                <p>As a dedicated digital designer with over 6 years of experience, I bring ideas to life through thoughtful web development, creative graphic design, and engaging video editing, always focused on delivering high-quality results that make an impact. My passion for blending technology and creativity drives me to craft digital solutions that not only look great but also solve real problems and help brands grow.</p>
                                <div className="about-info">
                                    <h4>Isuru Gimhan</h4>
                                    <span>- Digital Designer</span>
                                </div>
                                <div className="signeture">
                                    <img src={sign} alt="Isuru Gimhan signature" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="light-shape-1"></div>
            <div className="light-shape-2"></div>
            <div className="light-shape-3"></div>
        </section>
    )
}

export default About4;